// /auth/silent-callback: página mínima carregada no iframe da renovação silenciosa (oidc-client-ts). Só entrega a
// resposta do provedor à janela pai — nunca monta o shell, nunca chama a API (tratada no bootstrap, antes do React).
import { UserManager, type UserManagerSettings } from 'oidc-client-ts';

export async function runSilentCallback(
  settings: UserManagerSettings,
  createUserManager: (
    settings: UserManagerSettings,
  ) => Pick<UserManager, 'signinSilentCallback'> = (s) => new UserManager(s),
): Promise<void> {
  try {
    await createUserManager(settings).signinSilentCallback();
  } catch {
    // A janela pai trata o erro (timeout/`login_required`) e volta ao login interativo.
  }
}
